<script setup>
import { ref, toRefs, onBeforeMount, computed } from 'vue'
import mySwal from '@/src/javascripts/plugins/mySwal.js'
import { SendOutlined } from '@ant-design/icons-vue'
import BaseRadio from '@/src/vueComponent/BaseRadio.vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseSelect from '@/src/vueComponent/BaseSelect.vue'
import BackButton from '@/src/vueComponent/BackButton.vue'

const props = defineProps({
  token: {
    type: String
  },
  unitInfo: {
    type: Object,
    default: () => {
      return {
        id: null,
        code: '',
        name: '',
        manager_ids: [],
        state: ''
      }
    }
  },
  managers: {
    type: Array
  }
})
const { token, unitInfo, managers } = toRefs(props)
const editUnitInfo = ref(unitInfo.value)
const managerList = ref([])

onBeforeMount(() => {
  editUnitInfo.value = {
    ...editUnitInfo.value,
    manager_ids: editUnitInfo.value.manager_ids || []
  }
  managerList.value = managers.value.map((manager) => {
    return {
      value: manager.id,
      label: manager.name
    }
  })
})

const isDefaultState = computed(() => {
  return editUnitInfo.value.state === 'default'
})

const selectManager = (event) => {
  editUnitInfo.value.manager_ids = [...editUnitInfo.value.manager_ids, event]
}

const removeManager = (event) => {
  const index = editUnitInfo.value.manager_ids.findIndex((managerID) => {
    return managerID === event
  })
  editUnitInfo.value.manager_ids = [
    ...editUnitInfo.value.manager_ids.slice(0, index),
    ...editUnitInfo.value.manager_ids.slice(index + 1)
  ]
}

const submitForm = () => {
  $.ajax({
    url: editUnitInfo.value.id ? `/settings/units/${editUnitInfo.value.id}` : '/settings/units',
    type: editUnitInfo.value.id ? 'PATCH' : 'POST',
    dataType: 'json',
    headers: { 'X-CSRF-Token': token.value },
    authenticity_token: true,
    data: editUnitInfo.value,
    success: async (response) => {
      if (response.state === 0) {
        window.location.replace('/settings/units')
      }
    },
    error: async (error) => {
      console.log('error', error)
      if (error.responseJSON.state === -1) {
        await mySwal.error({
          title: error.responseJSON.message.join('<br />'),
          timer: 3000
        })

        if (error.responseJSON.redirect_to) {
          window.location.replace(error.responseJSON.redirect_to)
        }
      }
    }
  })
}
</script>
<template>
  <form @submit.prevent="submitForm" class="leave-need-confirm">
    <div class="mb-3">
      <p class="flex items-baseline gap-1 py-1 text-lg font-bold">
        <span>狀態</span>
        <span v-if="!isDefaultState" class="text-sm font-light text-red-400">*</span>
      </p>
      <div class="mb-4 flex gap-3">
        <BaseRadio
          :label="'啟用'"
          :name="'state'"
          :value="'enable'"
          v-model="editUnitInfo.state"
          :required="!isDefaultState"
          :disabled="isDefaultState"
        />
        <BaseRadio
          :label="'停用'"
          :name="'state'"
          :value="'disable'"
          v-model="editUnitInfo.state"
          :required="!isDefaultState"
          :disabled="isDefaultState"
        />
      </div>
      <div class="mb-4 grid grid-cols-4 gap-4 md:grid-cols-2">
        <BaseTextInput
          :label="'編號'"
          :name="'account'"
          v-model="editUnitInfo.code"
          :maxlength="20"
          required
        />
        <BaseTextInput
          :label="'名稱'"
          :name="'name'"
          v-model="editUnitInfo.name"
          :maxlength="20"
          :required="!isDefaultState"
          :disabled="isDefaultState"
        />
        <BaseSelect
          :label="'主管'"
          :name="'manager_ids[]'"
          :optionList="managerList"
          :optionsSelected="editUnitInfo.manager_ids"
          @select="selectManager"
          @deselect="removeManager"
          class="col-span-2"
          multiple
          :required="editUnitInfo.id !== null"
        />
      </div>
    </div>
    <div class="flex items-center justify-end gap-3 py-3">
      <BackButton :hasForm="true" :returnPath="'/settings/units'" />
      <button type="submit" class="btn btn-success text-xl text-white">
        <SendOutlined />
        送出
      </button>
    </div>
  </form>
</template>
